const beepUrl = new URL("../../../assets/scanner-beep-90395.mp3", import.meta.url).href;

/**
 * One silent sample. iOS ignores HTMLAudioElement.volume, so priming with the
 * beep file itself is audible before any code is read.
 */
export const SCAN_BEEP_PRIME_SRC =
  "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=";

let clip: HTMLAudioElement | null = null;

function beepClip(): HTMLAudioElement | null {
  if (typeof window === "undefined") return null;
  if (!clip) clip = new Audio();
  return clip;
}

/** Unlock playback on the scan tap. Does not play the beep. */
export function primeScanBeep(): void {
  const audio = beepClip();
  if (!audio) return;
  audio.src = SCAN_BEEP_PRIME_SRC;
  void audio.play().then(() => {
    audio.pause();
    audio.currentTime = 0;
  }).catch(() => undefined);
}

/** Plays assets/scanner-beep-90395.mp3 after a code is actually read. */
export function playScanBeep(): void {
  const audio = beepClip() ?? new Audio();
  audio.src = beepUrl;
  audio.currentTime = 0;
  void audio.play().catch(() => undefined);
}
